import styled from 'styled-components';

import { TButtonTypes } from './Button.types';

export const ButtonContainer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	align-self: stretch;
	gap: 12px;
`;

export const Button = styled.div<{ type: TButtonTypes }>`
	width: 100%;
	height: 44px;
	padding: 10px;
	border-radius: 8px;

	display: flex;
	justify-content: center;
	align-items: center;
	gap: 4px;

	cursor: pointer;

	background-color: ${({ theme, type }) =>
		type === 'confirm' ? theme['orange-secondary'] : theme['warmgray-100']};
`;

export const CloseIconWrapper = styled.div`
	svg {
		path {
			stroke: ${({ theme }) => theme['white-primary']};
		}
	}
	width: 18px;
	height: 18px;

	position: absolute;
	top: -24px;
	right: 0px;

	padding: 5px;
`;

export const SingleInputFormPopupSubmitButton = styled.button`
	border: none;
	background-color: inherit;
`;
